<template>
  <div>
    <el-table class="right-block" size="small" :data="listData" border>
      <el-table-column prop="id" width="80" label="序号" align="center"> </el-table-column>
      <el-table-column prop="title" label="学校" align="center"> </el-table-column>
      <el-table-column prop="wtypes" label="数量" align="center">
        <template slot-scope="scope">
          <div
            @click="handleEdit(scope.$index)"
            v-for="item in scope.row.elist"
            :key="item[0]"
          >
            {{ item[0] }}x{{ item[1] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="st" label="备注" align="center"> </el-table-column>
      <el-table-column width="200" prop="begin" label="申请时间" align="center"> </el-table-column>
    </el-table>

    <el-dialog
      :title="title"
      width="1000px"
      :visible.sync="editFormVisible"
      @click="closeDialog('edit')"
    >
      <div class="info-block">
        <div class="info-block-l">
          <!-- 学校信息头部 -->
          <div class="info-header">
            <div class="info-title">{{ editForm.deptName }}</div>
            <el-tag size="small" type="primary" effect="dark">当前申请</el-tag>
          </div>
          <div class="info-des">{{ editForm.des }}</div>

          <!-- 当前申请详情卡片 -->
          <div class="current-application">
            <div class="current-app-body">
              <div class="app-item">
                <span class="app-label">项目数量：</span>
                <span class="app-tags">
                  <el-tag
                    size="small"
                    v-for="(items, idx) in editForm.elist"
                    :key="idx"
                    type="primary"
                    effect="plain"
                  >
                    {{ items[0] }} x {{ items[1] }}
                  </el-tag>
                </span>
              </div>
              <div class="app-item" v-if="editForm.st">
                <span class="app-label">备注：</span>
                <span class="app-value">{{ editForm.st }}</span>
              </div>
              <div class="app-item">
                <span class="app-label">联系人：</span>
                <span class="app-value">{{ editForm.phone }}</span>
              </div>
            </div>
          </div>

          <!-- 历史申请记录 -->
          <div class="history-section">
            <div class="history-header">
              <span class="section-label">历史申请记录</span>
              <el-tag size="mini" type="info" effect="plain">共 {{ baoming.length }} 条</el-tag>
            </div>
            <div class="info-block-r">
              <div v-if="baoming.length > 0" :stretch="true" v-model="activeName">
                <div v-for="(item, index) in baoming" :key="index">
                  <div class="stu-list">
                    <div class="stu-top">
                      <div><span class="label">申请ID：</span>{{ item.id }}</div>
                      <div>
                        <span class="label">项目数量：</span>
                        <span v-for="(items, idx) in item.elist" :key="idx">
                          {{ items[0] }}x{{ items[1] }}&nbsp;
                        </span>
                      </div>
                      <div v-if="item.st"><span class="label">备注：</span>{{ item.st }}</div>
                      <div><span class="label">更新时间：</span>{{ item.begin }}</div>
                      <div><span class="label">电话号码：</span>{{ item.phone }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-history">暂无历史申请记录</div>
            </div>
          </div>
        </div>

        <!-- 按钮区域 -->
        <div class="dialog-footer">
          <el-button
            class="stu-bottom-button"
            size="mini"
            type="success"
            @click="refuseTheStu(0)"
            plain
            >接收</el-button
          >
          <el-button
            class="stu-bottom-button"
            size="mini"
            type="warning"
            @click="refuseTheStu(1)"
            plain
            >驳回</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
function getevent(arr, i, it) {
  if (it == i.length) {
    return arr[0];
  } else {
    return arr[0] + '-' + getevent(arr[parseInt(i[it]) + 1], i, it + 1);
  }
}
import {
  GetTheWorktingList,
  SubmitReviewResults,
  formatTime,
  PictureServer,
  GetTheWorkInfo,
} from '../../api/userMG';
export default {
  data() {
    return {
      theindex: 0,
      listData: [],
      cInfo: JSON.parse(localStorage.getItem('userInfo')),
      editFormVisible: false,
      editForm: {
        deptName: '',
        price: '',
        phone: '',
        skill: '',
        des: '',
        urls: '',
        elist: [],
        st: '',
      },
      baoming: [],
      imgh: PictureServer.Info,
      imghl: PictureServer.Log,
      znums: 0,
      xnums: 0,
      zlist: '',
      activeName: '',
    };
  },
  created() {
    GetTheWorktingList().then((res) => {
      var works = [],
        items = null,
        contes = res.c,
        elist = [];
      this.zlist = JSON.parse(res.c);
      res.w.forEach((e) => {
        var ss = e[3].split('|'),
          sit;
        elist = [];
        for (var i = 0; i < ss.length; i++) {
          sit = ss[i].split(',');
          elist.push([
            getevent(
              this.zlist[parseInt(sit[0][0]) + 1],
              sit[0].substring(1, sit[0].length),
              0
            ),
            sit[1],
          ]);
        }
        items = {
          id: e[0],
          uid: e[1],
          st: e[2],
          elist: elist,
          begin: formatTime(new Date(e[5])),
          sid: e[4],
        };
        for (var j = 0; j < res.s.length; j++) {
          if (res.s[j][0] == e[4]) {
            items.title = res.s[j][1]+(res.s[j][2]=='99'?'{机构}':(res.s[j][2]=='98'?'{政府组织}':''));
            break;
          }
        }
        works.push(items);
      });
      this.listData = works;
    });
  },
  methods: {
    handleEdit: function (index) {
      this.editFormVisible = false;
      this.theindex = index;
      this.title = '申请信息';
      GetTheWorkInfo(35, this.listData[index].sid, this.listData[index].uid).then(
        (res) => {
          var s1 = res.s.at(-1);
          var s2 = res.w.pop();
          this.editForm.deptName = this.listData[index].title;
          this.editForm.wtypes = this.listData[index].wtypes;
          this.editForm.phone = s1[1];
          this.editForm.elist = this.listData[index].elist;
          this.editForm.st = this.listData[index].st;
          this.editForm.des = s2[0] || '未认证';
          var ll = [],
            ss,
            sit,
            elist,
            items;
          for (var j = 0; j < res.w.length; j++) {
            for (var k = 0; k < res.s.length; k++) {
              if (res.w[j][1] == res.s[k][0]) {
                ss = res.w[j][3].split('|');
                elist = [];
                for (var i = 0; i < ss.length; i++) {
                  sit = ss[i].split(',');
                  elist.push([
                    getevent(
                      this.zlist[parseInt(sit[0][0]) + 1],
                      sit[0].substring(1, sit[0].length),
                      0
                    ),
                    sit[1],
                  ]);
                }
                items = {
                  id: res.w[j][0],
                  uid: res.w[j][1],
                  st: res.w[j][2],
                  elist: elist,
                  begin: formatTime(new Date(res.w[j][4])),
                  phone: res.s[k][1],
                };
                ll.push(items);
                break;
              }
            }
          }
          this.baoming = ll;
          this.editFormVisible = true;
        }
      );
    },
    closeDialog() {
      this.editFormVisible = false;
    },
    refuseTheStu(t) {
      var that = this;
      if (t) {
        this.$prompt('请说明不通过的原因', '将驳回用户提交进度', {
          inputErrorMessage: '输入不能为空',
          inputValidator: (value) => {
            if (!value) {
              return '输入不能为空';
            }
          },
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          SubmitReviewResults({
            i: this.listData[that.theindex].id,
            c: value,
            k: '0',
          }).then((res) => {
            if (res) {
              that.listData.splice(that.theindex, 1);
              that.$message.success('已驳回');
            }
          });
        });
      } else {
        this.$prompt('请输入工作评价', '接收并确认工作进度', {
          inputValue: '已确认完成',
          inputErrorMessage: '输入不能为空',
          inputValidator: (value) => {
            if (!value) {
              return '输入不能为空';
            }
          },
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          SubmitReviewResults({
            i: that.listData[that.theindex].id,
            c: value,
            k: '1',
          }).then((res) => {
            if (res) {
              that.listData.splice(that.theindex, 1);
              that.$message.success('已通过审核');
            }
          });
        });
      }
    },
  },
};
</script>

<style scoped>
/* ====== 统一定义 ====== */
:root {
  --primary: #409eff;
  --primary-light: #ecf5ff;
  --primary-border: #b3d8ff;
  --success: #67c23a;
  --warning: #e6a23c;
  --radius: 8px;
  --shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  --transition: 0.25s;
}

/* 表格美化 */
.right-block {
  margin-top: 16px;
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow);
}
.right-block ::v-deep .el-table__row {
  transition: background var(--transition);
}
.right-block ::v-deep .el-table__row:hover {
  background-color: #f5f9ff !important;
}
.right-block ::v-deep .el-table .cell {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  padding: 6px 0;
}
.right-block ::v-deep .el-table .cell > div {
  background: #f0f7ff;
  padding: 2px 12px;
  border-radius: 14px;
  font-size: 13px;
  color: #2c3e50;
  cursor: pointer;
  transition: all var(--transition);
  border: 1px solid transparent;
}
.right-block ::v-deep .el-table .cell > div:hover {
  background: var(--primary);
  color: #fff;
  border-color: var(--primary);
  transform: scale(1.03);
}

/* 对话框整体 */
.el-dialog {
  border-radius: var(--radius) !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15) !important;
}
.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
  padding: 18px 24px !important;
  background: #fafafa;
  border-radius: var(--radius) var(--radius) 0 0;
}
.el-dialog__title {
  font-weight: 600;
  font-size: 18px;
  color: #303133;
}
.el-dialog__body {
  padding: 24px !important;
}

/* ---------- 信息主体 ---------- */
.info-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.info-block-l {
  background: #fff;
  padding: 16px 20px;
  border-radius: var(--radius);
  border: 1px solid #ebeef5;
  box-shadow: var(--shadow);
}

/* ---------- 学校信息头部 ---------- */
.info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.info-title {
  font-size: 22px;
  font-weight: 700;
  color: #1f2f3d;
  letter-spacing: 1px;
}
.info-des {
  padding: 8px 0 12px 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.7;
  border-bottom: 1px solid #ebeef5;
  white-space: pre-line;
}

/* ---------- 当前申请卡片 ---------- */
.current-application {
  margin: 16px 0 20px 0;
  background: var(--primary-light);
  border: 1px solid var(--primary-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.section-label {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
}
.current-app-body {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.app-item {
  display: flex;
  align-items: baseline;
  font-size: 14px;
  color: #303133;
  line-height: 1.6;
}
.app-label {
  font-weight: 600;
  color: #606266;
  min-width: 80px;
  flex-shrink: 0;
}
.app-value {
  color: #303133;
}
.app-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.app-tags .el-tag {
  margin-right: 0;
}

/* ---------- 历史记录区域 ---------- */
.history-section {
  margin-top: 4px;
}
.history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 12px 0;
  border-bottom: 2px solid #ebeef5;
  margin-bottom: 12px;
}
.history-header .section-label {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}
.history-header .section-label::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 16px;
  background: var(--primary);
  border-radius: 2px;
  margin-right: 8px;
  vertical-align: middle;
}

/* ---------- 报名列表 ---------- */
.info-block-r {
  max-height: 380px;
  overflow-y: auto;
  padding-right: 4px;
}
.info-block-r::-webkit-scrollbar {
  width: 6px;
}
.info-block-r::-webkit-scrollbar-thumb {
  background: #c1c9d6;
  border-radius: 10px;
}
.info-block-r::-webkit-scrollbar-track {
  background: #f0f2f5;
}

/* 历史记录卡片 */
.stu-list {
  background: #f9fafc;
  border-radius: var(--radius);
  padding: 12px 16px;
  margin-bottom: 10px;
  border-left: 3px solid #c0c4cc;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all var(--transition);
}
.stu-list:hover {
  background: #f5f7fa;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.stu-list:last-child {
  margin-bottom: 0;
}

.stu-top {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.stu-top > div {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}
.stu-top .label {
  font-weight: 600;
  color: #909399;
  min-width: 80px;
  flex-shrink: 0;
}
.stu-top > div span:not(.label) {
  background: #f0f2f5;
  padding: 0 10px;
  border-radius: 12px;
  margin-right: 4px;
  font-size: 12px;
  color: #606266;
}

/* 空状态 */
.empty-history {
  text-align: center;
  color: #c0c4cc;
  padding: 30px 0;
  font-size: 14px;
}

/* ---------- 底部按钮区域 ---------- */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 20px;
  background: #fafafa;
  border-top: 1px solid #e4e7ed;
  border-radius: 0 0 var(--radius) var(--radius);
  margin-top: 4px;
}

.stu-bottom-button {
  min-width: 80px;
  border-radius: 20px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all var(--transition);
}
.stu-bottom-button.el-button--success {
  background-color: var(--success);
  border-color: var(--success);
  color: #fff;
}
.stu-bottom-button.el-button--success:hover {
  background-color: #85ce61;
  border-color: #85ce61;
  box-shadow: 0 4px 10px rgba(103, 194, 58, 0.3);
}
.stu-bottom-button.el-button--warning {
  background-color: var(--warning);
  border-color: var(--warning);
  color: #fff;
}
.stu-bottom-button.el-button--warning:hover {
  background-color: #ebb563;
  border-color: #ebb563;
  box-shadow: 0 4px 10px rgba(230, 162, 60, 0.3);
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .el-dialog {
    width: 92% !important;
  }
  .info-block-l {
    padding: 12px;
  }
  .app-label,
  .stu-top .label {
    min-width: 60px;
  }
  .info-header {
    flex-wrap: wrap;
    gap: 8px;
  }
  .dialog-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .stu-bottom-button {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/contest/working.vue